__turbopack_context__.v({
  "className": "nunito_e95eaa1a-module__J68LqW__className",
  "variable": "nunito_e95eaa1a-module__J68LqW__variable",
});
